// Util
NP.Util = (function( window, $ ) {
	var util = {};

	// Validation
	util.validate = function( text ) {
		if ( !text ) {
			return '';
		}

		return text.replace( /</g, '&lt;' ).replace( />/g, '&gt;' ).replace( /&lt;br \/&gt;/g, '<br />' );
	};

	util.getTemplate = function( template ){
		return doT.template( template );
	};

	util.hbParser = function( a, b ){
		if( !handlebar ){ alert('undefined handlebar');}
		var template = Handlebars.compile( a );
		return template( b );
	};

	util.getCaretPosition = function( $input ){
		var input = $input.get( 0 );
		if( !input ) return 0;

		if( 'selectionStart' in input ){
			return input.selectionStart;
		}else if( document.selection ){
			var sel = document.selection.createRange();
			var len = document.selection.createRange().text.length;
			sel.moveStart( 'character', -input.value.length );
			return sel.text.length - len;
		}
	};

	// 템플릿 compiler
    util.compile = function( _target ) {
        for ( var property in _target ) {
            if ( typeof _target[ property ] === 'object' ) {
                this.compile( _target[ property ] );
            } else if ( _target.hasOwnProperty( property ) ) {
                _target[ property ] = doT.template( _target[ property ] );
            }
        }
    };

	// Template Parser
	util.tplParser = function( a, b ) {
		return a;

//		return function( c, d ) {
//			return a.replace( /@{([^}]*)}/g, function( a, e ) {
//				return Function( "x", "with( x ) return " + e ).call( c, d || b || {} )
//			} );
//		};
	};

	// Align Center
	util.setCenter = function( o ) {
		var w = $( window ),
			wH = w.height(), wW = w.width(),
			sT = w.scrollTop(), sL = w.scrollLeft();

		$( o ).each(function() {
			var el = $( this ),
				oH = el.outerHeight(),
				oW = el.outerWidth();

			el.css({
				top : wH >= oH ? ( wH - oH ) / 2 + sT : !sT ? 0 : sT,
				left : wW >= oW ? ( wW - oW ) / 2 + sL : sL
			});
		});
	};

	// Stack
	util.stack = function( target, value ) {
		var isRep = !1,
			i = target.length;

		while ( i-- ) {
			if ( target[ i ][ 0 ] === value ) {
				target.splice( i, 1 );
				isRep = !0;
				break;
			}
		}
		target.push( $( value ) );

		return isRep;
	};

	// Count Text
	util.count = function( text ) {
		var len = text.length,
			ret = 0;

		while ( len-- ) {
			if ( text.charCodeAt( len ) < 0 || text.charCodeAt( len ) > 127 ) {
				ret += 2;
			} else {
				ret++;
			}
		}

		return ret;
	};

	// 조사 붙이기
	util.josa = function( text, josa, str ) {
		var code = text.charCodeAt( text.length - 1 ) - 44032,
			str = str || '',
			josa = [
				[ '를', '을' ],
				[ '로', '으로' ],
				[ '라', '이라' ]
			][ josa ];

		// 한글이 아닐 경우
		if ( ( code >= 0x3130 && code <= 0x318F ) || code >= 0xAC00 && code <= 0xD7A3 ) {
			return text;
		}

		text = text + str;

		if ( code % 28 === 0 ) { // 받침 없음
			return text + josa[ 0 ];
		} else { // 받침 있음
			return text + josa[ 1 ];
		}
	};

	// ellipsis
	util.ellipsis = function( text, limit ) {
		text = text.replace( /</g, '&lt;' ).replace( />/g, '&gt;' );
		if ( text.length > limit ) {
			//return ( text.replace( '<br />', '\n' ).substr( 0, limit - 3 ) ).replace( '\n', '<br />' ) + '...';
			return ( text.replace( /<br \/>/g, '\n' ).substr( 0, limit - 3 ) ).replace( /\n/g, '<br />' ) + '...';
		}

		return ( text.replace( '<br />', '\n' ).substr( 0, limit - 3 ) ).replace( '\n', '<br />' );
	};

	// Get URL Parameter
	util.getParam = function( paramName ) {
		var _ret = '',
			href = location.href,
			found = !1,
			compareString = paramName + '=',
			compareLength = compareString.length;

		if ( href.indexOf( '?' ) > -1 ) {
			var strQueryString = href.substr( href.indexOf( '?' ) + 1 ),
				aQueryString = strQueryString.split( '&' ),
				i = 0,
				str;

			for ( ; str = aQueryString[ i ]; i += 1 ) {
				if ( str.substr( 0, compareLength ) === compareString ) {
					var aParam = str.split( '=' );

					_ret = parseInt( aParam[ 1 ], 10 );
					found = !0;

					break;
				}
			}
		}

		if ( !found ) {
			return '';
		}

		return _ret;
	};

	util.getGUID = function() {
		return location.pathname.split( '/' )[ 1 ] || '';
	};

	util.isGUID = function( id ){
//		if( id.length > 20 ) return true;
//		return false;
		return !!( /\w{8}-\w{4}-\w{4}-\w{4}-\w{12}/.test( id ) );
	};

    util.stripTags = function( text, allowTags ) {
		return text.replace( new RegExp( !( allowTags && allowTags.length ) ? '<\/?[^>]+>' : '<\\/?(?!(' + allowTags.join( '|' ) + '))\\b[^>]+>', 'gi' ), '' );
	};

	util.isSandbox = function(){
		return ( location.href.indexOf( 'sandbox.plaync.com' ) !== -1 )? true: false;

	};

	return util;
}( window, jQuery ));

// Random
NP.random = (function() {
	var saved = 0;

	return {
		get : function( max ) {
			if ( !max ) return;

			var random = parseInt( Math.random() * max );
			while ( saved === random ) {
				random = parseInt( Math.random() * max );
			}

			return saved = random;
		}
	};
}());

// Auto Link
NP.AutoLink = function( text ) {
	var sticker = '';
	if( /{{.+}}$/.test( text ) ){
		sticker = /{{.+}}$/.exec( text );
		sticker = sticker[ 0 ];
		text = text.replace( sticker, '' );
	}

	//text = text.replace( /<br \/>/g, ' <br />' ).replace( /(\s?(?:https?:\/\/|www)+[-\S.]+\s?)/ig, " <a class='js_link' href='$1' target='_blank'>$1</a> " ).replace( "<a class='js_link' href='www", "<a class='js_link' href='http://www" );
	text = text.replace( /<br \/>/g, ' <br />' ).replace( /(\s?)(?:https?:\/\/|www)+[-\S.]+(\s?)/ig, function( a, b, c, d ) {
		a = a.replace( /\s/g, '' );

		return b + "<a class='js_link' href='" + ( /^www/.test( a ) ? "http://" + a : a ) + "'" + ( /(plaync.com|plaync.co.kr)/.test( a ) ? "" : " target='_blank'" ) + ">" + a + "</a>" + c;
	});

	if( sticker ) text = text + sticker;

	return text;
};

NP.isRc = (location.href.indexOf( 'rc.' ) !== -1 )? 'rc.': '';

NP.getCharThumb = function( id, serverId ){
	if( !id ) return '';

    if(NP.isRc){
        return 'https://rc-profileimg.plaync.com/game_profile_images/aion/images?charKey='+id+'&gameServerKey='+serverId;
    }else{
        return 'https://profileimg.plaync.com/game_profile_images/aion/images?charKey='+id+'&gameServerKey='+serverId;
    }

	// var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

	// function encode64(input) {
	//     var output = "";
	//     var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
	//     var i = 0;
	//     input = utf8_encode(input);
	//     while (i < input.length) {
	//         chr1 = input.charCodeAt(i++);
	//         chr2 = input.charCodeAt(i++);
	//         chr3 = input.charCodeAt(i++);
	//         enc1 = chr1 >> 2;
	//         enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	//         enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	//         enc4 = chr3 & 63;
	//         if (isNaN(chr2)) {
	//             enc3 = enc4 = 64;
	//         } else if (isNaN(chr3)) {
	//             enc4 = 64;
	//         }
	//         output = output +
	//         _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
	//         _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
	//     }
	//     return output;
	// }

	// function utf8_encode(string) {
	//     string = string.replace(/\r\n/g, "\n");
	//     var utftext = "";
	//     for (var n = 0; n < string.length; n++) {
	//         var c = string.charCodeAt(n);
	//         if (c < 128) {
	//             utftext += String.fromCharCode(c);
	//         }else if ((c > 127) && (c < 2048)) {
	//             utftext += String.fromCharCode((c >> 6) | 192);
	//             utftext += String.fromCharCode((c & 63) | 128);
	//         } else {
	//             utftext += String.fromCharCode((c >> 12) | 224);
	//             utftext += String.fromCharCode(((c >> 6) & 63) | 128);
	//             utftext += String.fromCharCode((c & 63) | 128);
	//         }
	//     }
	//     return utftext;
	// }

	// var url = 'http://' + NP.isRc + NP.gamePicUrl +'/images/0301',
	// 	base64 = encode64( id ),
	// 	sBase64 = base64.substring( base64.length - 4 );

	// url += '/' + serverId;

	// return url + '/' + sBase64 + '/' + base64 + '.jpg';
};

// Get Profile URI
NP.prflUri = function( id ) {
	return 'https://' + ( /rc\-/.test( location.host )?'rc-':'' ) + NP.sandboxUrl + '/' + id;
	//return '/' + id + '/bns/timeline/wall';
	//return '/' + id + '/bns/timeline/wall?sub_template=profile';
};

NP.getPostLocation = function( id ){

	var s = '';
	switch( id ){
		case 143:
			//s = '공통';
			break;
		case 144:
			//s = 'NP SNS';
			break;
		case 145:
			s = '블소';
			break;
		case 146:
			s = '아이온';
			break;
		case 925:
			//s = 'NP SNS';
			break;
	}


	return s;
};

NP.articleInfoOpen = function( data ){
	var s = '';
	if ( data.post.postTxtOpenClfSeq === 118 ) { // 전체공개
		s += '<span class="access"><span class="js_tooltip all" data-tooltip="전체공개">전체공개</span></span>';
	} else if ( data.post.postTxtOpenClfSeq === 119 ) { // 친구공개
		s += '<span class="access"><span class="js_tooltip friend" data-tooltip="친구공개">친구공개</span></span>';
	} else if ( data.post.postTxtOpenClfSeq === 120 ) { // 그룹공개
		var gNm = NP.getPostLocation( data.post.postTxtServClfSeq );

		gNm = ( gNm === '아이온')? '레기온': '문파원';

		s += '<span class="access"><span class="js_tooltip group" data-tooltip="' + data.post.postTxtTorgNm + '의' + gNm + '공개">' + data.post.postTxtTorgNm + '의 ' + gNm + '공개</span></span>';
	}

	return s;
};

NP.articleToInfo = function( data, crrDttm, postNm, postUrl ){
	var s = '',
		bar =  ' <span class="bar">|</span> ',
		loc = NP.getPostLocation( data.post.postTxtServClfSeq ),
		nm = ( data.postTorg == 'CHARACTER_GUESTBOOK' )? data.post.postTxtTorgChrtNm: postNm,
		url = postUrl,
		gCont = data.post.gameContClfSeq,
		gContArr = [ 1211, 1212, 1213, 1214, 1215, 1216, 1311 ],
		gContNm = data.post.postTxtTorgNm;

	s += '<time>' + NP.Time( crrDttm ) + '</time>' + bar;
	//s += '<time>' + NP.Time( crrDttm ) + '</time> ';

	if( loc ){
		s += '<span class="option">' + loc + '</span>' + bar;
	}
	//TODO postUrl로 링크값을 변경해야함
	if( nm ){
		s += '<span class="option">'+nm+'</span>' + bar;
	}

	if( gCont && NP.dt.page !== 'group' ){
		var i = 0;
		for( var len = gContArr.length; len > i; i++){
			if( gCont == gContArr[ i ]){
				s += '<span class="option">' + gContNm + '문파제작공방</span>' + bar;
				break;
			}
		}
	};

	if( data.post.wrtLocClfSeq == 124 ){
		s += '<span class="option">모바일에서</span>' + bar;
	}else if( data.post.wrtLocClfSeq == 123 ){
		s += '<span class="option">PC웹에서</span>' + bar;
	}else if( data.post.wrtLocClfSeq == 125 ){
		s += '<span class="option">게임에서</span>' + bar;
	}

	s += NP.articleInfoOpen( data );

	return s;
};

NP.articleInfo = function( data, crrDttm, postNm ){
	var s = '',
		bar =  ' <span class="bar">|</span> ',
		loc = NP.getPostLocation( data.post.postTxtServClfSeq ),
		nm = ( data.postTorg == 'CHARACTER_GUESTBOOK' )? data.post.postTxtTorgChrtNm: postNm,
		gCont = data.post.gameContClfSeq;
		
		

	s += '<time>' + NP.Time( crrDttm ) + '</time>' + bar;
	//s += '<time>' + NP.Time( crrDttm ) + '</time> ';

	if( loc ){
		s += '<span class="option">' + loc + '</span>' + bar;
	}

	if( nm && nm != '0' ){
		//페이지가 그룹이 아닐때 출처 노출
		if( ( NP.dt.page !== 'group' && NP.dt.page !== 'groupdonate' ) && ( data.post.postTxtTorgClfSeq == 153 ) ){
			if( data.post.postTxtServClfSeq === 145 || data.post.postTxtTorgGameId === 102 ){
				if( (/1294|1295|1296|1297|1298/i.test( gCont ) ) ){
					//s += '<span>' + nm + ' 문파제작공방</span>' + bar;
				}else{
					s += '<span>' + nm + ' 문파방명록</span>' + bar;
				}
			}else if( data.post.postTxtServClfSeq === 146 || data.post.postTxtTorgGameId === 101 ){
				s += '<span><a href="'+ NP.aionGroupGuestbookUri( data.post.postTxtTorgChrtId, data.post.postTxtTorgSvrId ) +'">' + nm + ' 레기온방명록</a></span>' + bar;
			}
		}

		if( data.post.gameContYn == 'Y' && !(/1294|1295|1296|1297|1298|1211|1212|1213|1214|1215|1216|1311/i.test( gCont ) ) ){
			s += '<span class="option">'+ nm +'</span>' + bar;
		}

		//페이지가 캐릭터방명록이 아닐때 출처 노출
		if( NP.dt.page !== 'characterguestbook' && data.postTorg == 'CHARACTER_GUESTBOOK'){
			if( data.post.postTxtServClfSeq === 145 || data.post.postTxtTorgGameId === 102 ){
				s += '<span><a href="'+ NP.bnsPrflUri( data.post.postTxtTorgChrtNm, data.post.postTxtTorgSvrId ) +'">'+ nm +' 캐릭터방명록</a></span>' + bar;
			}else if( data.post.postTxtServClfSeq === 146 || data.post.postTxtTorgGameId === 101 ){
				s += '<span><a href="'+ NP.aionPrflUri( data.post.postTxtTorgChrtId, data.post.postTxtTorgSvrId ) +'">'+ nm +' 캐릭터방명록</a></span>' + bar;
			}
		}

		//그룹글일 경우 처리
		if( ( NP.dt.page !== 'group' && NP.dt.page !== 'groupdonate' && NP.dt.page !== 'groupreceive' && NP.dt.page !== 'groupsign' ) 
			&& ( data.postTorg == 'GROUP' ||  data.postTorg == 'GROUP_DONATE' ||  data.postTorg == 'GROUP_RECEIVE' || data.postTorg == 'GROUP_SIGN' ) ){
			var torg = '',
				site = ( data.post.postTxtServClfSeq == 146 || data.post.postTxtTorgGameId == 101 )?
						'aion': ( data.post.postTxtServClfSeq == 145  || data.post.postTxtTorgGameId == 102 )?
						'bns': '';

			if( gCont && data.post.gameContYn == 'Y' && ( /1211|1212|1213|1214|1215|1216|1311/i.test( gCont ) ) ){
				s += '<span class="option">' + nm + ' 문파제작공방</span>' + bar;
			}else if( /1294|1295|1296|1297|1298/i.test( gCont ) ){
				s += '<span class="option">' + nm + ' 문파제작공방</span>' + bar;
			}else if( /1294|1295|1296|1297|1298/i.test( gCont ) ){
			}else{
				if( site == 'aion' ) torg = ' 레기온 이야기';

				if( site ){

					var homeurl = 'https://sandbox.plaync.com/';
					if ( /rc\.|rc\-/.test( location.host ) ) {
						homeurl = 'https://rc-sandbox.plaync.com/';
					}

					s += '<span><a href="'+ homeurl + data.post.wrtPlayncAcctId + '/'+ site +'/timeline/group?trgtId=' + data.post.postTxtTorgId +'">' + ( nm + torg ) + '</a></span>' + bar;
				}else{
					s += '<span>' + nm + '</span>' + bar;
				}
			}
		}

	}

	//if( post.actClfSeq == 127 && data.post.wrtLocClfSeq == 124 ){
	if( data.post.wrtLocClfSeq == 124 ){
		s += '<span class="option">모바일에서</span>' + bar;
	}else if( data.post.wrtLocClfSeq == 123 ){
		s += '<span class="option">PC웹에서</span>' + bar;
	}else if( data.post.wrtLocClfSeq == 125 ){
		s += '<span class="option">게임에서</span>' + bar;
	}

	s += NP.articleInfoOpen( data );

	return s;
};

NP.bnsPrflUri = function( nm, serverId, serverType ) {
	if( !nm ) return '';
	// var serverTxt = '';
	// if( serverId ) serverTxt = '?s=' + serverId;
	// return 'http://' + NP.isRc + NP.bnsUrl +'/bs/character/guestbook/' + nm + serverTxt;
	// return 'http://' + NP.isRc + NP.bnsUrl +'/bs /character/profile/' + nm;
	return 'https://' + (NP.isRc?'rc-': '') + NP.bnsUrl +'/world/character/' + serverType + '/' + serverId + '/' + nm;
};

NP.aionPrflUri = function( id, servId ) {
	if( !id ) return '';
	return 'http://' + NP.isRc + NP.aionUrl +'/characters/' + servId + '/' + id + '/go';
};

NP.aionGroupGuestbookUri = function(id, servId){
	return 'http://' + NP.isRc + NP.aionUrl + '/legions/' + servId + '/' + id + '/go';
};

NP.replyThumb = function( data ){

	var s = '', thumb = 'cThumb';

	if( !NP.isHideNick( data ) ){
		s = '<a href="' + NP.prflUri( data.wrtPlayncAcctId ) + '" class="' + thumb + '"><img src="'+ NP.sfile( data.wrtPlayncAcctId )+ '" alt="'+ data.wrtPlayncAcctNm +'"></a>';
	}else{
		if( data.wrtGameId === '101' && data.wrtChrtId && data.wrtChrtNm ){
			var t = NP.getCharThumb( data.wrtChrtId, data.wrtSvrId );
			s = '<a href="' + NP.aionPrflUri( data.wrtChrtId, data.wrtSvrId ) + '" class="' + thumb + '"><img src="'+ t + '" alt="'+ data.wrtChrtNm +'" onerror="this.src=\'https://wstatic-cdn.plaync.com/resource/aion/race/race_no_signature.gif\'"></a>';
		}else if( data.wrtGameId === '102' && data.wrtChrtId && data.wrtChrtNm ){
			s = '<a href="' + NP.bnsPrflUri( data.wrtChrtNm, data.wrtSvrId, data.wrtGameSvrType ) + '" class="' + thumb + '"><img src="'+ NP.sfile( data.wrtPlayncAcctId )+ '" alt="'+ data.wrtPlayncAcctNm +'"></a>';
		}
	}

	return s;
};

NP.articleLikeThumb = function( data, isReply ){

	var s = '', thumb = 'thumb';

	if( !data.orgWrtPlayncAcctId ) data.orgWrtPlayncAcctId = data.orgWrtPlayncAccId;
	if( !data.orgWrtPlayncAcctNm ) data.orgWrtPlayncAcctNm = data.orgWrtPlayncAccNm;

	if( isReply ) thumb = 'cThumb';
	if( !NP.isHideNick( data ) ){
		s = '<a href="' + NP.prflUri( data.orgWrtPlayncAcctId ) + '" class="' + thumb + '"><img src="'+ NP.sfile( data.orgWrtPlayncAcctId )+ '" alt="'+ data.orgWrtPlayncAcctNm +'"></a>';
	}else{
		if( data.orgWrtGameId == '101' && data.orgWrtChrtId ){
			var t = NP.getCharThumb( data.orgWrtChrtId, data.orgWrtSvrId );
			s = '<a href="' + NP.aionPrflUri( data.orgWrtChrtId, data.orgWrtSvrId ) + '" class="' + thumb + '"><img src="'+ t + '" alt="'+ data.orgWrtChrtNm +'" onerror="this.src=\'https://wstatic-cdn.plaync.com/resource/aion/race/race_no_signature.gif\'"></a>';
		}else{
			s = '<a href="' + NP.bnsPrflUri( data.orgWrtPlayncAcctNm, data.orgWrtSvrId ) + '" class="' + thumb + '"><img src="'+ NP.sfile( data.orgWrtPlayncAcctId )+ '" alt="'+ data.orgWrtPlayncAcctNm +'"></a>';
		}
	}

	return s;
};

NP.articleThumb = function( data, isReply ){
	var s = '', thumb = 'thumb';

	if( !data.post ){
		data.post = {};
		data.post.wrtPlayncAcctId = data.wrtPlayncAcctId;
		data.post.wrtPlayncAcctNm = data.wrtPlayncAcctNm;
	}

	if( isReply ) thumb = 'cThumb';
	if( !NP.isHideNick( data ) ){
		s = '<a href="' + NP.prflUri( data.post.wrtPlayncAcctId ) + '" class="' + thumb + '"><img src="'+ NP.sfile( data.post.wrtPlayncAcctId )+ '" alt="'+ data.post.wrtPlayncAcctNm +'"></a>';
	}else{
		if( data.post.wrtGameId == '101' && data.post.wrtChrtId ){//aion
			var t = NP.getCharThumb( data.post.wrtChrtId, data.post.wrtSvrId );
			s = '<a href="' + NP.aionPrflUri( data.post.wrtChrtId, data.post.wrtSvrId ) + '" class="' + thumb + '"><img src="'+ t + '" alt="'+ data.post.wrtChrtNm +'" onerror="this.src=\'https://wstatic-cdn.plaync.com/resource/aion/race/race_no_signature.gif\'"></a>';
		};

		if( data.post.wrtGameId == '102' && data.post.wrtChrtId ){//bns
			s = '<a href="' + NP.bnsPrflUri( data.post.wrtChrtNm, data.post.wrtSvrId, data.wrtGameSvrType ) + '" class="' + thumb + '"><img src="'+ NP.sfile( data.post.wrtPlayncAcctId )+ '" alt="'+ data.post.wrtPlayncAcctNm +'"></a>';

		};

		if( !data.post.wrtChrtId && data.post.postTxtTorgGameId == '101' && data.postTorg == 'CHARACTER_GUESTBOOK' ){
			s = '<span class="' + thumb + '"><img src="https://wstatic-cdn.plaync.com/resource/aion/race/race_no_signature.gif" alt="캐릭터명확인불가"></span>';
		};
	}

	return s;
};

NP.isNeedCharacterBns = function( data ){
	var sId = data.postTxtServClfSeq,
		gId = data.postTxtTorgGameId;

	if( sId == '145' || gId == '102' ){
		if( data.postTorg === 'CHARACTER_GUESTBOOK' || data.postTorg === 'GROUP_GUESTBOOK' || data.postTorg === 'GROUP' )
			return true;
	}

	return false;
};

NP.isNeedCharacter = function( data ){
	var sId = data.postTxtServClfSeq,
		gId = data.postTxtTorgGameId;

	if( sId == '146' || gId == '101' ){
		if( data.postTorg === 'CHARACTER_GUESTBOOK' || data.postTorg === 'GROUP_GUESTBOOK' || data.postTorg === 'GROUP' )
			return true;
	}

	return false;
};

NP.isHideNick = function( data ){

	if( data.postTxtTorgGameId  == 101 ) return true;

	if( data.post && data.post.postTxtTorgGameId  == 101 ) return true;

	var gId = data.postTxtTorgGameId || ( data.post && data.post.postTxtTorgGameId );
	var gSId = data.postTxtServClfSeq || ( data.post && data.post.postTxtServClfSeq );

	if( gId == '101' || gSId == '146' ){
		if(  data.postTorg === 'CHARACTER_GUESTBOOK' || data.postTorg === 'CHARACTER_GUESTBOOK' ||
			 data.postTorg === 'CHARACTER_GUESTBOOK' )
			return true;
	}

	if( NP.dt.st === 'aion' ){
		if( NP.dt.page === 'characterguestbook' || NP.dt.page === 'groupguestbook' ||
			NP.dt.page === 'group' ){
			return true;
		}
	}

	return false;
};

NP.replyNick = function( data ){

	var s = '';

	if( !NP.isHideNick( data ) ){
		s = NP.setNick({
			postTxtTorgId: data.wrtPlayncAcctId,
			postTxtTorgNm: data.wrtPlayncAcctNm
		});
	};

	if( data.wrtChrtId && data.wrtGameId == "102" ){
		s += '<a class="game" href="'+NP.bnsPrflUri( encodeURIComponent( data.wrtChrtNm ), data.wrtSvrId, data.wrtGameSvrType )+'">[' + data.wrtChrtNm + ']</a> ';
	};

	if( data.wrtChrtId && data.wrtGameId == "101" ){
		s += '<a class="game" href="'+NP.aionPrflUri( data.wrtChrtId, data.wrtSvrId )+'">[' + data.wrtChrtNm + ']</a> ';
	};

	return s;
};

NP.openCharacterGuestbook = function( data ){
	var s = '';
	if( data.st === 'aion' ){
		var t = NP.getCharThumb( data.characterId, data.serverId );

		s = '<article class="article openServiceInfo">';
		s += '<a class="thumb"><img src="' + t + '" alt="' + data.oNm +'"  onerror="this.src=\'https://wstatic-cdn.plaync.com/resource/aion/race/race_no_signature.gif\'"></a>';
		s += '<div class="content"><a class="game" href="' + NP.aionPrflUri( data.characterId, data.serverId ) +'">[' + data.oNm + ']</a>님의 방명록이 열렸습니다.</div></article>';
	}else if( data.st === 'bns' ){
		s = '<article class="article openServiceInfo"><a class="thumb"><img src="'+ NP.sfile( data.o )+ '" alt="'+ data.oNm +'"></a>';
		s += '<div class="content"><div class="identity">';
		s +='</div>\<a class="game">[' + data.oNm + ']</a>님의 방명록이 열렸습니다.</div></article>';
	};

	return s;
};

NP.openGroupGuestbook = function( data ){
	var s = '';
	s = '<article class="article openServiceGroupInfo"><a class="thumb"><img src="' + NP.RESOURCE_URL + 'icon/nc.gif" alt=""></a><div class="content">['+data.gNm+'] 방명록에 한마디 남겨주세요.</div></article>';
	return s;
};

NP.articleNick = function( data ){
	var s = '';

	if( !NP.isHideNick( data ) ){
		s = NP.setNick({
			postTxtTorgId: data.post.wrtPlayncAcctId,
			postTxtTorgNm: data.post.wrtPlayncAcctNm
		});
	};

	if( data.post.wrtChrtId && data.post.wrtChrtNm && data.post.wrtGameId == "102" ){
		s += '<a class="game" href="https://'+ (NP.isRc?'rc-': '') + NP.bnsUrl +'/world/character/' + data.post.wrtGameSvrType + '/' + data.post.wrtSvrId + '/' + encodeURIComponent( data.post.wrtChrtNm )  + '">[' + data.post.wrtChrtNm + ']</a>';
		// s += '<a class="game" href="http://'+ NP.isRc + NP.bnsUrl +'/bs /character/profile/' + encodeURIComponent( data.post.wrtChrtNm )  + '">[' + data.post.wrtChrtNm + ']</a>';
		// s += '<a class="game" href="http://'+ NP.isRc + NP.bnsUrl +'/bs/character/guestbook/' + encodeURIComponent( data.post.wrtChrtNm ) + '?s=' + data.post.wrtSvrId + '">[' + data.post.wrtChrtNm + ']</a>';
	};

	if( data.post.wrtChrtId && data.post.wrtChrtNm && data.post.wrtGameId == "101" ){
		s += '<a class="game" href="'+NP.aionPrflUri( data.post.wrtChrtId, data.post.wrtSvrId )+'">[' + data.post.wrtChrtNm + ']</a>';
	};

	if( !data.post.wrtChrtId && data.post.postTxtTorgGameId == '101' && data.postTorg == 'CHARACTER_GUESTBOOK' ){
		s = '<span class="game">[캐릭터명확인불가]</span>';
	};

	return s;

};

NP.articleLikeNick = function( data ){
	console.log('--', data)
	var s = '';

	if( !NP.isHideNick( data ) ){
		s = NP.setNick({
			postTxtTorgId: ( data.orgWrtPlayncAcctId || data.orgWrtPlayncAccId ),
			postTxtTorgNm: ( data.orgWrtPlayncAcctNm || data.orgWrtPlayncAccNm )
		});
	}

	if( data.orgWrtChrtId && data.orgWrtChrtNm && data.orgWrtGameId == "102" ){
		s += '<a class="game" href="https://'+ (NP.isRc?'rc-': '') + NP.bnsUrl +'/world/character/' + data.wrtGameSvrType + '/' + data.wrtSvrId + '/' + encodeURIComponent( data.orgWrtChrtNm ) + '">[' + data.orgWrtChrtNm + ']</a>';
		//s += '<a class="game" href="http://'+ NP.isRc + NP.bnsUrl +'/bs/character/guestbook/' + encodeURIComponent( data.orgWrtChrtNm ) + '?s=' + data.orgWrtSvrId + '">[' + data.orgWrtChrtNm + ']</a>';
	}

	if( data.orgWrtChrtId && data.orgWrtChrtNm && data.orgWrtGameId == "101" ){
		s += '<a class="game" href="'+NP.aionPrflUri( data.orgWrtChrtId, data.orgWrtSvrId )+'">[' + data.orgWrtChrtNm + ']</a>';
	}

	return s;

};

NP.setNick = function( data ){
	var postTxtTorgId = data.postTxtTorgId,
		postTxtTorgNm = data.postTxtTorgNm,
		postTxtTorgChrtId = data.postTxtTorgChrtId || '',
		postTxtTorgSvrId = data.postTxtTorgSvrId || '';


	if( !postTxtTorgId || !postTxtTorgNm ) return '';

	var link = '';

	if( NP.Util.isGUID( postTxtTorgId ) ){
		link = NP.prflUri( postTxtTorgId );
		return '<a href="'+ link +'" class="js_mProfile nickname" data-np=\'{"id":"'+postTxtTorgId+'"}\'>'+postTxtTorgNm+'</a>';
	}else{
		link = '/!!/bns/timeline?c=' + postTxtTorgChrtId + '&s=' + postTxtTorgSvrId;
		return '<a href="'+ link +'" class="js_mProfile nickname" data-np=\'{"id":"'+postTxtTorgId+'", "cId":"'+postTxtTorgChrtId+'", "sId":"'+postTxtTorgSvrId+'"}\'>'+postTxtTorgNm+'</a>';
	};
};

NP.articleTo = function( data ){
	var s = '';
	if( data.postTorg === "GROUP_GUESTBOOK"){
		if( data.post.postTxtServClfSeq == 145 || data.post.postTxtTorgGameId == 102 ){
			s = " <span class=\"groupname\">"+data.post.postTxtTorgNm+"</span>방명록에";
		}else{
			s = " <a href=\""+ NP.aionGroupGuestbookUri( data.post.postTxtTorgChrtId, data.post.postTxtTorgSvrId ) +"\" class=\"groupname\">"+data.post.postTxtTorgNm+"</a>방명록에";
		}

	}else if( data.postTorg === "PROGILE"){
	}else if( data.postTorg === "GROUP_RECEIVE"){
	}else{
		if( data.post.postTxtTorgGameId == "101" )
			s = " <a href=\'" + NP.aionPrflUri( data.post.postTxtTorgChrtId, data.post.postTxtTorgSvrId ) + "\'>["+data.post.postTxtTorgNm+"]</a>님에게";
		if( data.post.postTxtTorgGameId == "102" || data.post.postTxtTorgGameId == "0" ){
			s = NP.setNick({
				postTxtTorgId: data.post.postTxtTorgId,
				postTxtTorgNm: data.post.postTxtTorgNm,
				postTxtTorgChrtId: data.post.postTxtTorgChrtId,
				postTxtTorgSvrId: data.post.postTxtTorgSvrId
			});

			if( data.postTorg === 'CHARACTER_GUESTBOOK' && ( data.post.postTxtTorgChrtId && data.post.postTxtTorgChrtNm && data.post.postTxtTorgGameId == "102" ) ){
				s += '<a class="game" href="https://'+ NP.isRc + NP.bnsUrl +'/bs/character/guestbook/' + encodeURIComponent( data.post.postTxtTorgChrtNm ) + '?s=' + data.post.postTxtTorgSvrId + '">[' + data.post.postTxtTorgChrtNm + ']</a>';
			};

			s += '님에게';
		}
	}

	return s;
};

// Get sfile URI
NP.sfile = function( id, type ) {
	//return NP.SFILE_URL + 'data/' + id + '/profile?type=' + ( type || 'small' );
	return NP.SFILE_URL + 'account_profile_images/' + id + '?imageSize=' + ( type || 'medium' );
};

NP.likeByArticle = function( html, data ){
	if( !html || !data ) return html;
	if( !data.post ) return html;
	if( !data.orgActType ) return html;
	if( data.orgPostTxtServClfSeq == 146 || data.orgPostTxtTorgGameId == 101 ) return html;

	var s = '<article class="article likeby" data-postTorg="'+data.postTorg+'" data-postTxtTorgGameId="'+data.post.postTxtTorgGameId+'" data-postTxtServClfSeq="'+data.post.postTxtServClfSeq+'">',
		e = '</article>',
		thumb = NP.articleLikeThumb( data, false ),
		nick = NP.articleLikeNick( data ),
		content = '<div class="content">' + nick + '님이 이 글을 좋아합니다.<div class="info"><time>' + NP.Time( data.orgCreDttm || data.post.creDttm ) + '</time></div></div>',
		menu = '<div class="wrap_menu"><a class="btn">이 글 메뉴</a><menu class="context"></menu></div>';

	html = s + thumb + content + menu + html + e;

	return html;
};

NP.likeBy = function( data ){
	var s = '';
	if( data.orgActType ){
		if( data.orgPostTxtServClfSeq == 146 || data.postTxtTorgGameId == 146 ){
			//s = '<p class=\'likeby\' data-sv=\''+data.orgWrtSvrId+'\' data-nm=\''+data.orgWrtChrtNm+'\' data-game=\''+ data.orgPostTxtServClfSeq +'\'><a href=\'' + NP.aionPrflUri( data.wrtChrtId, data.wrtSvrId ) + '\'>좋아요 by ' + data.wrtChrtNm + '</a></p>';
		}else{
			s = '<p class=\'likeby\' data-sv=\''+data.orgWrtSvrId+'\' data-nm=\''+data.orgWrtChrtNm+'\' data-game=\''+ data.orgPostTxtServClfSeq +'\'><a href=\'' + NP.prflUri( data.orgWrtPlayncAccId ) + '\'>좋아요 by ' + data.orgWrtPlayncAccNm + '</a></p>';
		}
	}

	return s;
};

// Type Conversion
NP.conv = function( value ) {
	value = value.split( '-' );
	//value = value[ 0 ] + '년 ' + value[ 1 ] + '월 ' + value[ 2 ] + '일';
	value = value[ 1 ] + '월 ' + value[ 2 ] + '일';

	return value;
};

// Control z-index
NP.zIndex = (function( $ ) {
	// Base z-index
	var z = 5000,
		// z-index term
		t = 20;

	return {
		get : function() {
			return z;
		},
		'+' : function( ctx ) {
			z = z + t;
			ctx && ctx.css( 'zIndex', z );
		},
		'-' : function( ctx ) {
			z = z - t;
			ctx && ctx.css( 'zIndex', '' );
		}
	};
}( jQuery ));

// Animate fadeIn
NP.fadeIn = function( target ) {
	target.animate({
		opacity : 1
	}, 300, function() {
		jQuery( this ).css( 'opacity', '' );
	});
};

// Animate fadeOut
NP.fadeOut = function( target ) {
	target.fadeOut( 300, function() {
		jQuery( this ).remove();
	});
};
